import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ProfileAccountComponent } from '@components/profile-account/profile-account.component';
import { ProfileContactsComponent } from '@components/profile-contacts/profile-contacts.component';
import { ProfileNotificationSettingsComponent } from '@components/profile-notification-settings/profile-notification-settings.component';
import { RecertificationComponent } from '@components/recertification/recertification.component';
import { WebComponentBootstrapModule } from 'src/boilerplate';
import { WebComponents } from 'src/boilerplate/WebComponentDecorator';
import { AuthInterceptorProvider } from './app/common/interceptors/auth.interceptor';
import { XsrfInterceptorProvider } from './app/common/interceptors/xsrf.interceptor';
import { OpenApiPathProvider, apiConfigFactory } from './app/common/util/open-api-provider';
import { ApiModule } from "./openapi-client";
import { TranslocoRootModule } from './transloco-root.module';

/**
 * THIS FILE IS ONLY FOR WEB COMPONENTS THAT SHOULD BE EXPORTED AS A LIBRARY!
 * NO DEMO COMPONENTS MUST BE INCLUDED!
 */

@WebComponents([
  ProfileAccountComponent,
  ProfileNotificationSettingsComponent,
  ProfileContactsComponent,
  RecertificationComponent,
])
@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslocoRootModule,
    ProfileAccountComponent,
    ProfileNotificationSettingsComponent,
    ProfileContactsComponent,
    RecertificationComponent,
    // Uncomment if Openapi is present
    ApiModule.forRoot(apiConfigFactory)
  ],
  providers: [
    AuthInterceptorProvider,
    XsrfInterceptorProvider,
    // Uncomment if OpenApi is present
    OpenApiPathProvider,
  ],

})
export class ExportModule extends WebComponentBootstrapModule {}
